import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var DownloadIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 12 15" }),
        React.createElement("path", { d: "M9.93429 5.14286H8.57143V0.857143C8.57143 0.385714 8.18571 0 7.71429 0H4.28571C3.81429 0 3.42857 0.385714 3.42857 0.857143V5.14286H2.06571C1.30286 5.14286 0.917143 6.06857 1.45714 6.60857L5.39143 10.5429C5.72571 10.8771 6.26571 10.8771 6.6 10.5429L10.5343 6.60857C11.0743 6.06857 10.6971 5.14286 9.93429 5.14286ZM0 13.7143C0 14.1857 0.385714 14.5714 0.857143 14.5714H11.1429C11.6143 14.5714 12 14.1857 12 13.7143C12 13.2429 11.6143 12.8571 11.1429 12.8571H0.857143C0.385714 12.8571 0 13.2429 0 13.7143Z" })));
};

export { DownloadIcon };
//# sourceMappingURL=DownloadIcon.esm.js.map
